pageId = 'members-created_todos-index'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-me').addClass('active')

  tower.adjustTodo()

  tower.scrollLoad $page, ->
    $.ajax
      url: location.href
      dataType: 'html'
      type: 'get'
      data:
        last_todo_guid: $('.todos .todo:last').data 'guid'
      success: (result) ->
        return unless result
        $result = $(result)
        tower.adjustTodo $result
        tower.adjustReadableDate $result
        tower.adjustReadableTime $result
        $('.todos').append $result
